// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__2hP1D","notes":"Notes_notes__OcevZ"};